import React from "react";

import {
  Button,
  Checkbox,
  message,
  Modal,
  Space,
  Table,
  Typography,
} from "antd";
import Text from "antd/lib/typography/Text";
import { useDispatch, useSelector } from "react-redux";
import { reportsApproval } from "../../../actions/companySettings";
import AddNewIcon from "../../../assets/icons/add_new_white.png";
import DeleteIcon from "../../../assets/icons/delete.png";
import EditIcon from "../../../assets/icons/edit.png";
import { hasAccess, objectToFormData } from "../../../utils";
import PageHeader from "../../PageHeader";
import {
  categories,
  categoriesStatus,
  categoriesStatusReset,
  deleteCategories,
  DeleteCategories,
  CategoriesStatus,
  AddCategories,
} from "./../../../actions/categories";
import AddCategory from "./AddCategory";

const { Title } = Typography;

const columns = [
  {
    title: "Name",
    dataIndex: "name",
    key: "name",
    render: (text, data) => {
      return (
        <div className={`render_common_style status_${data?.Status}`}>
          {text}
        </div>
      );
    },
  },
  {
    title: "Account Code",
    dataIndex: "account_code",
    key: "account_code",
  },
  // {
  //   title: 'Bill Mandatory',
  //   dataIndex: 'is_bill_mandatory',
  //   key: 'is_bill_mandatory',
  //   render: val => val ? 'Yes' : 'No',
  // },
];

message.config({
  maxCount: 3,
});

const Categories = () => {
  const [isModalVisible, setIsModalVisible] = React.useState(false);
  const [modalType, setIsModalType] = React.useState("center");
  const [tableData, setTableData] = React.useState([]);
  const [tableRowData, setTableRowData] = React.useState([]);
  const [selectedId, setSelectedId] = React.useState("");
  const [has_parent_id, setHas_parent_id] = React.useState("");
  const categoriesResponse = useSelector(
    (state) => state.categories.categories || {},
  );
  const categoriesStatusResponse = useSelector(
    (state) => state.categories.categoriesStatus || {},
  );
  const deleteCategoriesResponse = useSelector(
    (state) => state.categories.deleteCategories || {},
  );
  const addCategoriesResponse = useSelector(
    (state) => state.categories.addCategories || {},
  );
  const dispatch = useDispatch();

  const tableAction = [
    {
      title: "Enable",
      dataIndex: "is_enable",
      key: "is_enable",
      render: (is_enable, record) => (
        <Checkbox
          key={record.id}
          onChange={() =>
            dispatch(
              categoriesStatus(
                objectToFormData({
                  id: record.id,
                  is_enable: !record.is_enable,
                }),
              ),
            )
          }
          checked={is_enable}
          disabled={!hasAccess("categories", "write")}
        ></Checkbox>
      ),
    },
    !hasAccess("categories", "write")
      ? {}
      : {
          title: "Actions",
          key: "action",
          render: (text, record) => (
            <Space key={record.id} size="middle">
              <button
                onClick={() => showEditModal(record.id, record.parent_id)}
              >
                <img src={EditIcon} alt={"logo"} className="action-logo" />
              </button>
              <button onClick={() => showDeleteModal(record.id)}>
                <img src={DeleteIcon} alt={"logo"} className="action-logo" />
              </button>
            </Space>
          ),
        },
  ];

  // const onStatusChange = () => {

  // }

  const showDeleteModal = (id) => {
    setSelectedId(id);
    setIsModalVisible(true);
    setIsModalType("center");
  };

  const showEditModal = (id, parentId) => {
    setSelectedId(id);
    setHas_parent_id(parentId);
    setIsModalVisible(true);
    setIsModalType("right");
  };

  const showModal = () => {
    setSelectedId("");
    setIsModalVisible(true);
    setIsModalType("right");
  };

  React.useEffect(() => {
    dispatch(categories());
    setIsModalVisible(false);
    dispatch(reportsApproval({}));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const {
    data: {
      total_records = 0,
      response: { categories: categoriesData = [] } = {},
    } = {},
  } = categoriesResponse;
  React.useEffect(() => {
    if (categoriesResponse.success) {
      if (categoriesData.length) {
        const _categories = categoriesData.map(function (obj) {
          obj["children"] = obj["sub_categories"];
          return obj;
        });
        setIsModalVisible(false);
        setTableData(_categories);
        setTableRowData(
          _categories
            .map((value) => value.sub_categories.length && value.id)
            .filter(Boolean),
        );
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [categoriesResponse]);

  React.useEffect(() => {
    const {
      data: { message: res_message = "", status = "", errors = "" } = {},
    } = categoriesStatusResponse;
    if (status) {
      dispatch(categoriesStatusReset());
      dispatch(categories());
      dispatch({
        type: CategoriesStatus.RESET,
      });
    } else if (status === false && errors) {
      dispatch({
        type: CategoriesStatus.RESET,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [categoriesStatusResponse]);

  React.useEffect(() => {
    const {
      data: { message: res_message = "", status = "", errors = "" } = {},
    } = deleteCategoriesResponse;
    if (status) {
      setIsModalVisible(false);
      dispatch(categories());
      dispatch({
        type: DeleteCategories.RESET,
      });
    } else if (status === false && errors) {
      dispatch({
        type: DeleteCategories.RESET,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [deleteCategoriesResponse]);

  React.useEffect(() => {
    const {
      data: { message: res_message = "", status = "", errors = "" } = {},
    } = addCategoriesResponse;
    if (status) {
      setIsModalVisible(false);
      dispatch(categories());
      dispatch({
        type: AddCategories.RESET,
      });
    } else if (status === false && errors) {
      dispatch({
        type: AddCategories.RESET,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [addCategoriesResponse]);

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  function handleButtonClick(e) {
    showModal();
  }

  const renderDeleteOption = () => {
    return (
      <>
        <Text>Are you sure about deleting this category?</Text>
        <br />
        <br />
        <Button
          key="1"
          className="formButton mt1"
          onClick={() =>
            dispatch(deleteCategories(objectToFormData({ id: selectedId })))
          }
        >
          Delete
        </Button>
        <Button
          key="2"
          className="cancelButton ml1 mt1"
          onClick={() => handleCancel()}
        >
          Cancel
        </Button>
      </>
    );
  };

  return (
    <>
      <div className="heading-div">
        <PageHeader
          title={`Categories`}
          navigation={{
            Home: "/dashboard/",

            Categories: null,
          }}
        />
      </div>
      <Modal
        title={
          modalType === "center" ? (
            <>
              <img src={DeleteIcon} alt={"logo"} className="action-logo" />{" "}
              Delete Field
            </>
          ) : (
            <Title level={4}>
              {selectedId ? "Edit Category" : "New Category"} &nbsp;
              <span className="text-small">Enter details and submit</span>
            </Title>
          )
        }
        visible={isModalVisible}
        onCancel={handleCancel}
        footer={[]}
        className={
          modalType === "center"
            ? "center-aligned-modal"
            : "right-alinged-modal"
        }
      >
        {modalType === "center" ? (
          renderDeleteOption()
        ) : (
          <AddCategory
            id={selectedId}
            parentId={has_parent_id}
            handleCancel={handleCancel}
          />
        )}
      </Modal>
      {hasAccess("categories", "write") && (
        <Button
          onClick={handleButtonClick}
          className="mb1 ml1 addNew primaryButton"
        >
          <img src={AddNewIcon} alt={"logo"} className="addNew-logo" />
          Add New
        </Button>
      )}
      {tableData.length ? (
        <Table
          rowKey="id"
          columns={[...columns, ...tableAction]}
          dataSource={tableData}
          className="settingsTable"
          pagination={{
            total: total_records,
            onChange: (pagee) => {
              dispatch(
                categories({
                  page: pagee,
                  limit: 10,
                }),
              );
            },
          }}
          defaultExpandedRowKeys={[...tableRowData]}
        />
      ) : (
        <div className="table-placeholder">
          <div className="empty-normal">
            <div className="empty-description">No Data</div>
          </div>
        </div>
      )}
    </>
  );
};

export default Categories;
